<template>
<v-container>
  <v-card flat color="rgb(0,0,0,0)" width="100%">
    <div class="spinner"
      :style="{height, width}">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>

    <v-card flat
      color="rgb(0,0,0,0)"
      class="d-flex justify-center align-center"
      id="countIn-count"
      :style="{height, width, top, left}">
      <v-card-title :class="['text-h1', 'font-weight-bold', 'text--darken-3', 'countin-bounce']" style="min-width:5em;text-align:center;display:inline-block;">
        {{ countInCount > 0 ? countInCount : 'GO' }}
      </v-card-title>
    </v-card>
  </v-card>
</v-container>
</template>

<script>
  export default {
    name: 'CountIn',

    props: {
      id: Number,
      count: {
          default: function () {
              return 3
          },
          type: Number
      },
      width: {
          default: function () {
              return '15em'
          },
          type: String
      },
      height: {
          default: function () {
              return '15em'
          },
          type: String
      },
      active: {
          default: function () {
              return false
          },
          type: Boolean
      },
    },

    data: () => ({
        countInCount: 3,
        countInCounter: null,
        visible: false,
    }),
    
    computed: {
      top: function() {
        return `calc( 50% - ${parseInt(this.height)/2}em )`
      },
      left: function() {
        return `calc( 50% - ${parseInt(this.width)/2}em )`
      }
    },

    methods: {
      countIn() {
        clearInterval(this.countInCounter)

        if (this.countInCount > 0) {
          this.countInCount -= 1
          this.$emit('count-progress', this.countInCount)
          this.countInCounter = setInterval(this.countIn, 1000)
        } else {
          this.countInCounter = null
          this.countInCount = 0

          this.$emit('count-ended')
        }
      },

      setActive(val) {
        this.visible = val
        clearInterval(this.countInCounter)
        this.countInCounter = null

        if (val) {
          this.countInCount = this.count
          this.$emit('count-progress', this.countInCount)
          this.countInCounter = setInterval(this.countIn, 1000)
        }
      }
    },

    created() {
      this.setActive(this.active)
    },

    watch: {
      id: function(val) {
        console.log(val)
        this.countInCount = this.count
        this.setActive(this.active)
      },

      count: function(val) {
        console.log(val)
        this.countInCount = val
        this.setActive(this.active)
      },

      active: function(val) {
        this.setActive(val)
      },
    },
  }
</script>

<style scoped>
  #countIn-count {
    position: absolute;
  }

  .spinner {
    position: relative;
    margin: 10px auto;
  }

  .double-bounce1, .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: rgba(243, 243, 243, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    
    animation: sk-bounce 1s infinite ease-in-out;
  }

  .double-bounce2 {
    animation-delay: 0s;
  }

  .countin-bounce {
    animation: sk-bounce 1s infinite ease-in-out;
  }

  @keyframes sk-bounce {
    0%, 100% { 
      transform: scale(0.0);
    }
    50% { 
      transform: scale(1.0);
    }
  }

</style>